import React from 'react'
import { Grid, IconButton } from '@mui/material';
import { useRef, useState, useEffect } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import Cookies from 'js-cookie';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import axios from 'axios';
import { toast, Zoom } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import AppointmentStore from './DataRepository/AppointmentStore';
import { teleConsultationModel } from './Axios/AxiosConfig';
import loadingimg from './Assets/images/loading image 1.png';
import usePrescriptionStore from './DataRepository/Prescription'



function Main() {
    const containerRef = useRef(null);
    const [user, setuser] = useState();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [loading, setLoading] = useState(false);
    const { getNewAppointments, isNewAppointmentsLoading, NewAppointments } = AppointmentStore();
    // const { getNewAppointments, isNewAppointmentsLoading } = AppointmentStore();

    const [DateType, setType] = useState("monthly")
    const [Appointmentdata, setData] = useState(null)

    useEffect(() => {
        const updateDimensions = () => {
            if (containerRef.current) {
                setDimensions({
                    width: containerRef.current.offsetWidth,
                    height: containerRef.current.offsetHeight,
                });
            }
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    const doctorDetailsCookie = Cookies.get('Doctor_details');
    let Doctor_details = {};
    if (doctorDetailsCookie) {
        try {
            Doctor_details = JSON.parse(doctorDetailsCookie);
        } catch (error) {
            console.log('Error parsing Doctor_details cookie:', error);
        }
    }

    const getAppointmentData = async () => {
        try {
            setLoading(true);
            let res = await axios.post('https://z2t1vcmobj.execute-api.ap-south-1.amazonaws.com/dev/Appointmentdata', {
                DateType,
                Doc_id: Doctor_details.UID
            });
            if (res.status === 200) {
                setData(res.data);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);  // Stop Loader
        }
    };

    const UpdateAppointment = async (AppointmentID, key, value) => {
        try {
            setLoading(true);  // Start Loader
            const res = await teleConsultationModel.put('/UpdateOneAppointment', {
                AppointmentID,
                key,
                value
            });

            if (res?.status === 200) {
                getNewAppointments();
                toast.success("Confirmed Appointment Successfully", {
                    position: 'top-center',
                    limit: 1,
                    transition: Zoom,
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark'
                });
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);  // Stop Loader
        }
    };

    useEffect(() => {
        getAppointmentData()
    }, [DateType])

    useEffect(() => {
        getNewAppointments()
    }, [])

    const chartData = {
        data: [
            { id: 0, value: 25, label: 'Respiratory' },
            { id: 1, value: 40, label: 'Mental' },
            { id: 2, value: 30, label: 'Gastro' },
            { id: 3, value: 15, label: 'Hair & Skin' },
            { id: 4, value: 20, label: 'Physical' },
            { id: 5, value: 35, label: 'Women' },
            { id: 6, value: 10, label: 'Sexual' },
            { id: 7, value: 18, label: 'Metabolic' },
        ]
    };
    // const chartData = {
    //     data: [
    //         { id: 0, value: Appointmentdata?.categoryCounts?.Respiratory, label: 'Respiratory' },
    //         { id: 1, value: Appointmentdata?.categoryCounts?.Mental, label: 'Mental' },
    //         { id: 2, value: Appointmentdata?.categoryCounts?.Gastro, label: 'Gastro' },
    //         { id: 3, value: Appointmentdata?.categoryCounts?.['Hair & Skin'], label: 'Hair & Skin' },
    //         { id: 4, value: Appointmentdata?.categoryCounts?.Physical, label: 'Physical' },
    //         { id: 5, value: Appointmentdata?.categoryCounts?.Women, label: 'Women' },
    //         { id: 6, value: Appointmentdata?.categoryCounts?.Sexual, label: 'Sexual' },
    //         { id: 7, value: Appointmentdata?.categoryCounts?.Metabolic, label: 'Metabolic' },
    //     ]
    // };

    const dummyData =  {
        categoryCounts: {
            Respiratory: 10,
            Mental: 15,
            Gastro: 8,
            "Hair & Skin": 12,
            Physical: 9,
            Women: 14,
            Sexual: 7,
            Metabolic: 6
        },
        statusCounts: {
            cancelled: 2,
            rescheduled: 3,
            upcoming: 7
        },
        totalAppointments: 12,
        weekCounts: {
            week1: { upcoming: 2, cancelled: 1, rescheduled: 1 },
            week2: { upcoming: 1, cancelled: 0, rescheduled: 1 },
            week3: { upcoming: 2, cancelled: 1, rescheduled: 0 },
            week4: { upcoming: 1, cancelled: 0, rescheduled: 1 },
            week5: { upcoming: 1, cancelled: 0, rescheduled: 0 }
        }
    };
   
    const COLORS = ["#75623F", '#918165', '#A3967E', '#C0b7a7', '#F4D2B3', '#EEBC8F', '#E69E56', '#DA6E0B'];

    return <div>
        <div className='flex flex-row items-center justify-between p-3 appointmentinsightstitle '>


        </div>
        <div>
            {loading ? (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fdfdfd",
                    zIndex: 9999
                }}>
                    <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                        <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    {/* Your actual page content goes here */}
                </div>
            )}
        </div>

        <div className='flex justify-between p-5 gap-5'>
            <div className="Upcomingappointments">
                <p >New Appointments</p>
                <div className='divider border-[1px] padding-t-10'></div>


                {/* Show 'No New Appointments' message when the list is empty */}
                {NewAppointments?.length === 0 && (
                    <div className=" Upcomingappointments flex flex-col items-center justify-center h-[400px] text-center">
                        <img src="/icons/NoAppointment.png" alt="Time" className="w-80" />
                        <p>No New Appointments</p>
                    </div>
                )}

                <div className="flex flex-col gap-5 mt-5 overflow-y-auto scrollable-list" style={{ maxHeight: "70vh" }}>
                    {NewAppointments &&
                        NewAppointments
                            .sort((a, b) => new Date(b.appointment_date) - new Date(a.appointment_date))
                            .map((e, i) => (
                                <div key={i} className="w-100 p-5 bg-[#fdfdfd] rounded-md shadow newappointmentcard">
                                    <div className="flex-col">
                                        <p className="font-semibold">{e?.patient_name}</p>

                                        <div className="flex gap-4 items-center mt-2">
                                            <div className="flex gap-2 items-center">
                                                <img src="/icons/date.png" alt="Date" className="w-6" />
                                                <p>{e?.appointment_date.split("-").reverse().join("-")}</p>
                                            </div>

                                            <div className="flex gap-2 items-center">
                                                <img src="/icons/clock.png" alt="Time" className="w-6" />
                                                <p>{e?.appointment_time}</p>
                                            </div>

                                            <div className="flex gap-2 items-center">
                                                <img
                                                    className="w-6"
                                                    src={e?.consultation_type === "Video" ? "/icons/video.png" : "/icons/Audio.png"}
                                                    alt="Consultation Type"
                                                />
                                                <p>{e?.consultation_type}</p>
                                            </div>
                                        </div>
                                    </div>


                                    {/* Buttons */}
                                    <div className="flex flex-row gap-5 mt-5">
                                        <Button
                                            style={{
                                                width: "100%",
                                                textTransform: "none",
                                                border: "1px solid #DA6E0B",
                                                color: "#DA6E0B",
                                                borderRadius: "5px",
                                                fontSize: "10px", // Decreased font size
                                                fontWeight: 500,
                                                padding: "3px 8px", // Decreased padding
                                            }}
                                            component={Link}
                                            to={`/Reschedule/${e?.Appointment_id}`}
                                        >
                                            <EventRepeatIcon /> &nbsp; Reschedule
                                        </Button>

                                        <Button
                                            style={{
                                                width: "100%",
                                                textTransform: "none",
                                                backgroundColor: "#DA6E0B",
                                                color: "white",
                                                fontSize: "10px", // Decreased font size
                                                borderRadius: "5px",
                                                fontWeight: 500,
                                                padding: "6px 10px", // Decreased padding
                                            }}
                                            onClick={() => UpdateAppointment(e?.Appointment_id, "appointment_status", "confirmed")}
                                        >
                                            <TaskAltIcon /> &nbsp; Confirm
                                        </Button>
                                    </div>

                                </div>
                            ))}
                </div>
            </div>


            <div className="Insightsappointments">

                <div className="select-container">
                    <p >Appointment Insights </p>

                    <select value={DateType} className='styled-select' onChange={(e) => {
                        setType(e.target.value)
                    }}>
                        <option value={"daily"}>Daily</option>
                        <option value={"weekly"}>Weekly</option>
                        <option value={"monthly"}>Monthly</option>
                        <option value={"yearly"}>Yearly</option>

                    </select>
                </div>

                <div className='grid-container gap-5 mt-5'>
                    <div className='gcontent'>
                        <p>Total Appointments</p>
                        <p>{Appointmentdata?.totalAppointments || 0}</p>
                    </div>
                    <div className='gcontent'>
                        <p>Completed</p>
                        <p>{Appointmentdata?.statusCounts?.completed || 0}</p>
                    </div>
                    <div className='gcontent'>
                        <p>Cancelled</p>
                        <p>{Appointmentdata?.statusCounts?.cancelled || 0}</p>
                    </div>
                    <div className='gcontent'>
                        <p>Rescheduled</p>
                        <p>{Appointmentdata?.statusCounts?.rescheduled || 0}</p>
                    </div>

                </div>

                {/* <div className="flex space-x-4 ">
                    <div className='Appointment-insights-container'>

                        <div className='Apppointment-insights-page'>
                            <div className='charts gap-5 mt-5'>
                                <div ref={containerRef}>
                                    {Appointmentdata?.weekCounts && (
                                        <BarChart className='centerChar'
                                            xAxis={[{ scaleType: 'band', data: ['week1', 'week2', 'week3'] }]}
                                            yAxis={[
                                                {
                                                    label: 'No of Appointments',
                                                },
                                            ]}
                                            colors={["#8CEB8C", "#75623F", "#DA6E0B"]}
                                            width={350}
                                            height={300}
                                            series={[
                                                {
                                                    label: 'Upcoming',

                                                    data: Object.values(dummyData?.weekCounts.week1 || 0)
                                                },
                                                {
                                                    label: 'Cancelled',
                                                  
                                                    data: Object.values(dummyData?.weekCounts.week1 || 0)
                                                },
                                                {
                                                    label: 'Rescheduled',
                                                    data: Object.values(Appointmentdata?.weekCounts.week3)
                                                   
                                                },
                                            ]}
                                            borderRadius={20}
                                            sx={{
                                                [`.${axisClasses.left} .${axisClasses.label}`]: {
                                                    transform: 'translate(-10px)',
                                                   
                                                },
                                                [`.${axisClasses.dataLabelClass}`]: {
                                                   
                                                },
                                            }}
                                            slotProps={{
                                                legend: {
                                                    direction: 'row',
                                                    position: { vertical: 'bottom', horizontal: 'center' },
                                                    padding: 0,
                                                    itemMarkWidth: 10,
                                                    itemMarkHeight: 10,
                                                    labelStyle: {
                                                        fontSize: 12,
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='Appointment-insights-container'>
                        <div className='Apppointment-insights-page'>
                   

                            <div className='charts gap-5 mt-5'>
                                <div ref={containerRef}>
                                    {Appointmentdata?.categoryCounts && (
                                        <Box
                                            style={{
                                                
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                                width: '100%'
                                            }}
                                        >
                                            <PieChart
                                                sx={{
                                                 
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    margin: "auto",

                                                }}
                                                series={[
                                                    {
                                                        data: chartData.data.map((item, index) => ({
                                                            id: item.id,
                                                            value: item.value,
                                                            label: item.label,
                                                            color: COLORS[index % COLORS.length]
                                                        })),
                                                        innerRadius: 40,
                                                        outerRadius: 100,
                                                        highlightScope: { highlighted: 'item', faded: 'global' },
                                                    },
                                                ]}

                                                width={350}
                                                height={300}

                                                slotProps={{
                                                    legend: {
                                                        direction: 'row',
                                                        position: { vertical: 'bottom', horizontal: 'center' },
                                                        padding: 0,
                                                        itemMarkWidth: 10,
                                                        itemMarkHeight: 10,
                                                        labelStyle: {
                                                            fontSize: 12,
                                                        },
                                                    },
                                                }}
                                            />
                                        </Box>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div> */}
                
            </div>

        </div>

    </div>
}

export default Main